'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cx = _bind2.default.bind(_style2.default);

var Icon = function Icon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      color = _ref.color,
      focused = _ref.focused,
      hoverable = _ref.hoverable,
      rest = _objectWithoutProperties(_ref, ['name', 'size', 'color', 'focused', 'hoverable']);

  return _react2.default.createElement('i', _extends({}, rest, {
    className: cx('xsui-icon', 'xsui-icon-' + name, focused && 'xsui-icon--focused', hoverable && 'xsui-icon--hoverable'),
    style: { fontSize: size, color: color }
  }));
};

Icon.propTypes = {
  name: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  focused: _propTypes2.default.bool,
  hoverable: _propTypes2.default.bool
};

Icon.defaultProps = {
  color: 'inherit',
  size: 24,
  focused: false,
  hoverable: false
};

exports.default = Icon;